import React from "react"
import ProposalMergeFields from "../../../MergeFields"
import { getTextStyle } from "../text-and-image-row/helpers"
import { TextContent } from "../text-and-image-row/types"
import { Intl } from "../../../../state/helpers/IntlProps"



export interface TextContentSectionProps {
    content: TextContent
    variables: unknown
    isDummy: boolean
    intl: Intl
}


const TextContentSectionContent: React.FC<TextContentSectionProps> = ({ content, variables, isDummy, intl }) => {
    return (
        <div className="col-12 rich-text" style={getTextStyle({ content: content })}>
            <div dangerouslySetInnerHTML={{ __html: ProposalMergeFields.merge(content.text, variables, isDummy, intl) }} />
        </div>
    )

}

export { TextContentSectionContent }


// WEBPACK FOOTER //
// ./src/template/sections/content/text/TextContentSectionContent.tsx